<template>
  <div class="group-setup">
    <v-progress-linear
      indeterminate
      color="orange"
      v-if="loading"
    ></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-card class="pa-5">
      <v-card-title dark>
        <h3 class="ma-2">Participation at Club Officers Workshop</h3>
      </v-card-title>
      <v-divider></v-divider>
      <v-form>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-text-field
              outlined
              dense
              v-model="form.attended_officers_number"
              label=" No of attended officers*"
              required
              type="number"
            ></v-text-field>
            
          </v-col>
          <v-col cols="6" md="6" sm="12">           
             <v-switch
              v-model="form.president_attended"
              label="President attended"      
              value="1"
              hide-details
            ></v-switch>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4" md="4" sm="12">
              <v-switch
              v-model="form.secretary_attended"
              label="Secretary attended"      
               value="1"
              hide-details
            ></v-switch>
          </v-col>
           <v-col cols="4" md="4" sm="12">
              <v-switch
              v-model="form.treasurer_attended"
              label="Treasurer attended"      
               value="1"
              hide-details
            ></v-switch>
          </v-col>
          <v-col cols="4" md="4" sm="12">
              <v-switch
              v-model="form.membership_director_attended"
              label="Membership Director of the club"      
               value="1"
              hide-details
            ></v-switch>
          </v-col>
          
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-file-input
              outlined
              dense
              filled
              v-model="form.document1"
              prepend-icon="mdi-paperclip"
              label="Attach a copy of the certificate"
            ></v-file-input>
            <small>Max Size 500Kb </small>
          </v-col>
        </v-row>    
      </v-form>
      <v-divider></v-divider>
      <v-card-actions v-if="!cpRole">
        <v-row>
          <v-col cols="12" md="9" xs="6"></v-col>
          <v-col cols="12" md="3" xs="6">
            <v-btn
              large
              color="success"
              depressed
              :disabled="loading || !form.attended_officers_number"
              block
              @click="submit()"
              >Submit to Review</v-btn
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>   
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import Alert from "@/components/shared/Alert";
import { ActivityService } from "../../../services/activity-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "NewClubOfficerWorkshops",

  components: { Alert },

  data: () => ({
    cpRole: false,
    loading: false,
    errors: null,
    snackbar: false,
    successMsg: "",
    form: {
      attended_officers_number: 0,
      president_attended: 0,
      secretary_attended: 0,
      treasurer_attended: 0,
      membership_director_attended: 0,
      document1: null,
      members: [],
    },

    url: "new-club-officer-workshops",
  }),

  mounted() {},

  computed: {
    ...mapGetters({
      member: "profile",
    }),
  },

  methods: {
    submit() {
      this.errors = null;
      this.loading = true;
      this.snackbar = false;
      let fd = new FormData();
      fd.append("document1", this.form.document1);      
      fd.append(
        "attended_officers_number",
        this.form.attended_officers_number
      );
      fd.append(
        "leading_government_officers_number",
        this.form.leading_government_officers_number
      );
      fd.append("president_attended", this.form.president_attended ?? 0);
      fd.append("secretary_attended", this.form.secretary_attended ?? 0);
      fd.append("treasurer_attended", this.form.treasurer_attended ?? 0);
      fd.append("membership_director_attended", this.form.membership_director_attended ?? 0);
      fd.append("month", this.$route.params.month);
      fd.append("key", "PARTICIPATION_NEW_CLUB_OFFICERS_WORKSHOP");

      let data = fd;
      ActivityService.submitActivity(this.url, data)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.$router.push("/activities/monthly");
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    onDismissed() {
      this.errors = null;
    },
    closeSnackbar() {
      this.snackbar = false;
    },
    reset() {
      this.form.name = "";
    },
  },
};
</script>
